import './BetbookReactions.less';

import clsx from 'clsx';
import React from 'react';

import CommentIcon from '@/icons/CommentIcon';
import { formatMoneyAmount } from 'nike-ui/src/common/util';
import i18n from '@i18n';
import { POST_BLOG } from 'nike-ui/src/components/betbook/constants';
import EyeShowedIcon from 'nike-ui/src/icons/EyeShowedIcon';
import { ReactionButton } from '@/betbook/components/betbook-reactions/ReactionButton';

function BetbookPostReactions({
    className = '',
    commentsCount,
    customerComment,
    isInDetail = false,
    inspirationCount,
    onCommentClick = undefined,
    postType,
    stake = undefined,
    viewCount
}) {
    const isBlog = postType === POST_BLOG;
    return (
        <div
            className={clsx('betbook-reactions fs-14 flex flex-row justify-around', className, {
                'justify-end': isBlog
            })}
        >
            {(stake || inspirationCount) && !isBlog ? (
                <div className="flex flex-1">
                    {!isInDetail && !isBlog ? (
                        <>
                            <div className="flex items-center justify-center flex-col flex-1">
                                <div className="betbook-post-attribute pb-3 fs-12">
                                    {i18n('nui.betbook.inspiration-count')}
                                </div>
                                <div className="text-extra-bold fs-14">{inspirationCount || 0}</div>
                            </div>
                            <div className="betbook-post-attribute-separator" />
                        </>
                    ) : null}
                    {!isInDetail && !isBlog && stake ? (
                        <>
                            <div className="flex items-center justify-center flex-col flex-1">
                                <div className="betbook-post-attribute pb-3 fs-12">{i18n('jsp.tiket.vklad')}</div>
                                <div className="text-extra-bold fs-14">{formatMoneyAmount(stake, '\u20ac', 2)}</div>
                            </div>
                            <div className="betbook-post-attribute-separator" />
                        </>
                    ) : null}
                </div>
            ) : null}
            <div className="flex items-center flex-1 pt-2">
                <ReactionButton
                    isInDetail={isInDetail}
                    count={viewCount ? (viewCount > 999 ? '1K+' : viewCount) : 0}
                    icon={EyeShowedIcon}
                    data-atid="comment-reaction-seen"
                />

                {!isInDetail ? <div className="betbook-post-attribute-separator" /> : null}
                <ReactionButton
                    isInDetail={isInDetail}
                    count={commentsCount}
                    onClick={onCommentClick && onCommentClick}
                    active={customerComment}
                    icon={CommentIcon}
                    data-atid="comment-reaction-comment"
                />
            </div>
        </div>
    );
}

export default BetbookPostReactions;
